module.exports = __webpack_public_path__ + "img/2-19.7a1194af.jpg";